import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

const getCustomWorkflowTriggerMessageRequired = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return flags?.[FLAG_KEYS.CUSTOM_WORKFLOW_TRIGGER_MESSAGE_REQUIRED];
  }
);

export { getCustomWorkflowTriggerMessageRequired };
